import React from "react";
import { Typography } from "antd";
import { HoursProps } from "../types";
const { Text } = Typography;

/**
 * Displays hours converted from minutes
 * @param props - Component props
 * @param props.text - Time value in minutes
 * @returns Text component with formatted hours
 */
const Hours: React.FC<HoursProps> = ({ text }) => {
  return text !== null && text !== undefined ? (
    <Text>{Math.round((text / 60) * 100) / 100}</Text>
  ) : (
    <Text />
  );
};

export default Hours;
